var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.image.original_name)},on:{"click":function($event){return _vm.downloadImage(_vm.image)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }